import React from 'react';

function MiddleConnectorIcon(props: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div {...props}>
            <svg
                id="ejRQEYyVmgB1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 71 48"
                shapeRendering="geometricPrecision"
                textRendering="geometricPrecision"
            >
                <line x1="70.5" y1="24.5" x2="0.5" y2="24.5" fill="none" stroke="#cadbe8" strokeLinecap="round" />
            </svg>
        </div>
    );
}

export default MiddleConnectorIcon;
